<div class="map_wrapper">
  <div [id]="mapId" class="heatmap_container"></div>
  <div *ngIf="!searchPoints.length && isLoading" class="map_overlay_message">Loading data...</div>
  <div *ngIf="!searchPoints.length && !isLoading" class="map_overlay_message">No data available</div>
</div>
